export default {
    emailSettings: state => state.emailSettings,
}